import type { ExtractedSession, SessionToken } from './types';

export function extractSessionFromURL(url: string): ExtractedSession {
  const params = new URL(url).searchParams;
  const rawToken = params.get('session_token');
  const rawGameId = params.get('game_id');
  return {
    token: rawToken ? (rawToken as SessionToken) : null,
    gameId: rawGameId ? rawGameId : null,
  };
}
